import { type PermissionEnum } from "@dashboard/graphql";

/**
 * The agent-commission module is a JBM-custom backend addition, so
 * `MANAGE_AGENTS` is not present in the checked-in `schema-main.graphql`
 * snapshot and therefore not in the generated `PermissionEnum`. The backend
 * exposes it as `AgentPermissions.MANAGE_AGENTS` (`agent.manage_agents`) and
 * returns it in `user.userPermissions[].code`, so the literal is compared
 * as-is at runtime — mirrors `src/rewards/permissions.ts`. Once the schema
 * snapshot is refreshed this can be replaced with `PermissionEnum.MANAGE_AGENTS`.
 */
export const MANAGE_AGENTS = "MANAGE_AGENTS" as PermissionEnum;
